import { RENTAL_PORTAL_LISTINGS_LIST_API } from '../constants/api'
import { RENTAL_LISTING_ENTITY } from '../constants/entity'
import { deleteApi, getApi, patchApi, postApi, putApi } from '../utils/api'

export function getRentalPortalListingsPage(data) {
  return postApi({ data, endpoint: RENTAL_PORTAL_LISTINGS_LIST_API })
}

export function getRentalPortalListingsStatistic(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/rental-portal/listings/statistic/',
  })
}

export function updateRentalPortalListingsTableConfig(data) {
  return putApi({
    data,
    endpoint: `idwell-api/api/v3/table/tables/${RENTAL_LISTING_ENTITY.plural}/config/`,
  })
}

export function performRentalPortalListingsMassAction(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/rental-portal/listings/mass-action/',
  })
}

export function createRentalPortalListing(data) {
  return postApi({ data, endpoint: 'api/rental-portal/listings/' })
}

export function updateRentalPortalListing({ data, id, version }) {
  return patchApi({
    data: { ...data, version },
    endpoint: `api/rental-portal/listings/${id}/`,
  })
}

export function deactivateRentalPortalListing({ id, version }) {
  return postApi({
    data: { version },
    endpoint: `api/rental-portal/listings/${id}/deactivate/`,
  })
}

export function getRentalPortalListing(id) {
  return getApi({ endpoint: `api/rental-portal/listings/${id}/` })
}

export function getRentalPortalListingLogEvents({
  listing_id: listingId,
  ...params
}) {
  return getApi({
    endpoint: `api/rental-portal/listings/${listingId}/log-events/`,
    params,
  })
}

export function attachRentalPortalListingPhotos({ id, photos }) {
  return postApi({
    data: { photos },
    endpoint: `api/rental-portal/listings/${id}/photos/`,
  })
}

export function updateRentalPortalListingPhoto({ data, fileId, id }) {
  return patchApi({
    data,
    endpoint: `api/rental-portal/listings/${id}/photos/${fileId}/`,
  })
}

export function deleteRentalPortalListingPhoto({ fileId, id }) {
  return deleteApi({
    endpoint: `api/rental-portal/listings/${id}/photos/${fileId}/`,
  })
}

export function updateRentalPortalPublication({ data, id }) {
  return patchApi({ data, endpoint: `api/rental-portal/publications/${id}/` })
}

export function publishRentalPortalListingPortals({ data, id }) {
  return postApi({
    data,
    endpoint: `api/rental-portal/listings/${id}/portals/publish/`,
  })
}

export function updateRentalPortalListingPortals({ data, id }) {
  return postApi({
    data,
    endpoint: `api/rental-portal/listings/${id}/portals/update/`,
  })
}

export function deactivateRentalPortalListingPortals({ data, id }) {
  return postApi({
    data,
    endpoint: `api/rental-portal/listings/${id}/portals/deactivate/`,
  })
}

export function retryRentalPortalPublication(id) {
  return postApi({ endpoint: `api/rental-portal/publications/${id}/retry/` })
}

export function cancelRentalPortalPublicationSchedule({ id, scheduleType }) {
  return postApi({
    data: { which: scheduleType },
    endpoint: `api/rental-portal/publications/${id}/cancel-schedule/`,
  })
}

export function startRentalPortalListingsExport(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/rental-portal/listings/export/',
  })
}

export function loadRentalPortalListingsExportFieldsList() {
  return getApi({ endpoint: 'api/rental-portal/listing-export/fields-list/' })
}

export function checkRentalPortalListingsExportTask(id) {
  return getApi({ endpoint: `api/rental-portal/listing-export-task/${id}/` })
}
